import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
  DEFAULT_MAX_SVG_HEIGHT,
  DEFAULT_MIN_SVG_WIDTH,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import ContentfulFootnoteSup from '@entries/contentful-footnote-sup'
import { withDisplayName } from '@hocs/with-display-name'
import { MainCta } from '@layouts/main-cta'
import { paragraphP } from '@render-node/paragraph-p'
import { Entry } from '@resolvers/entry'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  width: '321px',
  height: '100%',
  minSvgWidth: DEFAULT_MIN_SVG_WIDTH,
  maxSvgHeight: DEFAULT_MAX_SVG_HEIGHT,
  objectFit: 'contain',
  alt: 'heroImage',
}

// TODO: move Offer title to its own component
const ContentfulPageImageTitlePictoHero: Utils.EntryFC<
  Queries.ContentfulPageImageTitlePictoHeroFragment
> = ({
  content: { offerRef, image, headline, subHeadline },
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const hasOfferTitle = Boolean(offerRef?.title)

  return (
    <div
      className="flex flex-col items-center py-10 laptop:flex-row"
      {...entryInspectorProps()}
    >
      <div className="flex flex-col items-center laptop:items-start">
        {hasOfferTitle && (
          <div className="mb-4 text-085 font-medium">
            <RichText
              {...fieldInspectorProps({
                fieldId: 'offerRef',
              })}
              content={offerRef.title}
              options={defaultRichTextFieldOptionsDeprecated}
            />
          </div>
        )}
        {headline && (
          <h1
            className="text-center text-230 leading-alternate"
            {...fieldInspectorProps({
              fieldId: 'headline',
            })}
          >
            {headline.text}
          </h1>
        )}
        {subHeadline && (
          <div>
            <RichText
              {...fieldInspectorProps({
                fieldId: 'subHeadline',
              })}
              content={subHeadline}
              options={{
                ...defaultRichTextFieldOptionsDeprecated,
                renderNode: {
                  ...defaultRichTextFieldOptionsDeprecated.renderNode,
                  [BLOCKS.PARAGRAPH]: paragraphP,
                  [INLINES.EMBEDDED_ENTRY]: {
                    [ContentType.ContentfulFootnote]: ContentfulFootnoteSup,
                  },
                },
              }}
            />
          </div>
        )}
        <MainCta />
      </div>
      {image && (
        <div
          className="mb-5 flex flex-grow items-center justify-center laptop:mb-0 laptop:ml-3 laptopL:ml-5"
          {...fieldInspectorProps({
            fieldId: 'image',
          })}
        >
          <AssetOptionsContext.Provider value={assetOptions}>
            <Entry
              content={image}
              mapping={{
                [ContentType.ContentfulAsset]: ContentfulAsset,
              }}
            />
          </AssetOptionsContext.Provider>
        </div>
      )}
    </div>
  )
}

export const query = graphql`
  fragment ContentfulPageImageTitlePictoHero on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    image {
      ...ContentfulDefaultAsset
    }
    offerRef {
      ...ContentfulOffer
    }
    headline {
      text
    }
    subHeadline {
      rich
      references {
        ...ContentfulFootnoteSup
      }
    }
  }
`

export default withDisplayName(
  ContentfulPageImageTitlePictoHero,
  'ContentfulPageImageTitlePictoHero'
)
